// Observação obrigatória por item do catálogo (Rafael 21/10, planilha de atributos 15-10): itens únicos que
// se repetem com o Clonar (Palestrante, Sala Evento, Brinde, DJ, Ativação...) exigem a observação da linha
// para dizer quem/qual é. Marca no catálogo: produto.orcamento_config.observacao_obrigatoria = true.
//
// Vale para linha NOVA (sem id; o clone nasce sem id) ou que TROCOU de item na tela — linha antiga já
// gravada não trava o Salvar (mesma régua da API, OrcamentoObservacaoObrigatoria). Basta observação em
// qualquer etapa (Pré-evento, Negociado ou Fechamento). O alerta aponta a do Pré-evento.

import { nomeItemAviso } from './nomeItemAvisoPolicy';

export const CAMPOS_OBSERVACAO = ['observacaoPreEvento', 'observacaoNegociado', 'observacaoFechamento'];

function configDoProduto(produto) {
    const config = produto?.orcamentoConfig ?? produto?.orcamento_config ?? null;
    if (typeof config === 'string') {
        try { return JSON.parse(config); } catch (e) { return null; }
    }
    return config && typeof config === 'object' ? config : null;
}

export function itemExigeObservacao(produto) {
    const valor = configDoProduto(produto)?.observacao_obrigatoria;
    if (valor === true || valor === 1) return true;
    return typeof valor === 'string' && ['1', 'true', 'sim'].includes(valor.trim().toLowerCase());
}

export function linhaTemObservacao(subitem) {
    return CAMPOS_OBSERVACAO.some((campo) => String(subitem?.[campo] ?? '').trim() !== '');
}

// Linha que a regra confere: nova (sem id) ou com o item trocado na tela (marca produtoTrocadoNaTela).
export function linhaConfereObservacao(subitem) {
    return !subitem?.id || subitem?.produtoTrocadoNaTela === true;
}

// Pendências no formato do alerta do rodapé (AlertaDadosInternacionais): { tipo, mensagem, alvo }.
export function listarPendenciasObservacao(orcamento = {}) {
    const erros = [];
    (orcamento?.orcamentoitem || []).forEach((grupo, grupoIndex) => {
        (grupo?.subitem || []).forEach((subitem, linhaIndex) => {
            if (!subitem?.produto?.id || !itemExigeObservacao(subitem.produto)) return;
            if (!linhaConfereObservacao(subitem) || linhaTemObservacao(subitem)) return;
            const item = nomeItemAviso(subitem.produto) || 'Item';
            const nomeGrupo = grupo?.produto?.nome ? ` (${grupo.produto.nome})` : '';
            erros.push({
                tipo: 'observacao',
                mensagem: `${item}${nomeGrupo}: preencha a observação para identificar este item (ex.: nome do palestrante, da sala, do brinde).`,
                alvo: { grupoIndex, linhaIndex, etapa: 'pre', campo: 'observacao' },
            });
        });
    });
    return erros;
}
